import { Component, computed, effect, inject, untracked } from '@angular/core';
import { Roles } from '@shared/util-auth';
import { CustomerStore, InvestmentService, TradeTransactionStore, UserStore } from '@shared/data';

@Component({
  selector: 'app-credit-limit-overrun-dialog',
  standalone: false,
  templateUrl: './credit-limit-overrun-dialog.component.html',
  styleUrl: './credit-limit-overrun-dialog.component.scss'
})
export class CreditLimitOverrunDialogComponent {
  overdraftDialogVisible = false;

  protected tradeTransactionStore = inject(TradeTransactionStore);
  private userStore = inject(UserStore);
  private customerStore = inject(CustomerStore);

  protected selectedCustomer = this.customerStore.customer;
  protected isDzBankUser = computed(() => Roles.DZ_ROLES.some((role) => this.userStore.roles().includes(role)));

  private investmentService = inject(InvestmentService);
  private tradeTransaction = this.tradeTransactionStore.tradeTransaction;
  private hasLinieUeberziehung = this.tradeTransactionStore.hasLinienUeberziehung;

  constructor() {
    effect(() => {
      const showDialog = this.hasLinieUeberziehung();

      untracked(() => {
        this.overdraftDialogVisible = showDialog;
      });
    });
  }

  processExecuteAfterLimitOverrun() {
    const tradeTransaction = this.tradeTransaction();
    const bestandEinhaltungOverride = tradeTransaction.bestandEinhaltungOverride;
    this.investmentService.processExecute(tradeTransaction, true, bestandEinhaltungOverride);

    this.tradeTransactionStore.updateHasLinienUeberziehung(false);
  }

  onCancel() {
    this.tradeTransactionStore.updateHasLinienUeberziehung(false);

    this.investmentService.resetStateForDialog();
  }
}
